__turbopack_context__.v({
  "loadingIndicator": "style-module-scss-module__Kx_qFG__loadingIndicator",
  "mobile": "style-module-scss-module__Kx_qFG__mobile",
  "predictionsDropdown": "style-module-scss-module__Kx_qFG__predictionsDropdown",
  "searchButton": "style-module-scss-module__Kx_qFG__searchButton",
  "searchContainer": "style-module-scss-module__Kx_qFG__searchContainer",
  "searchForm": "style-module-scss-module__Kx_qFG__searchForm",
  "searchInput": "style-module-scss-module__Kx_qFG__searchInput",
  "suggestedLocationDropdown": "style-module-scss-module__Kx_qFG__suggestedLocationDropdown",
});
